<template>
	<div>
		<div class="MarkerPopup-contents">
			<h3>
				<a target="_blank" :href="`https://regio.gripp.com/d/company/edit/${data.id}`">
					{{ fullname }}
				</a>
			</h3>
			<div class="MarkerPopup-address" v-if="data.visitingaddress_street">
				<div>{{ data.visitingaddress_street }} {{ data.visitingaddress_streetnumber }}</div>
				<div v-if="data.visitingaddress_zipcode">{{ data.visitingaddress_zipcode }}</div>
				<div v-if="data.visitingaddress_city">{{ data.visitingaddress_city }}</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="additional != null">
				<div class="appointment-item">
					<span>Leadkanaal:</span>
					<span>{{ additional.customfield_leadkanaal ? additional.customfield_leadkanaal : 'Onbekend' }}</span>
				</div>
				<div class="appointment-item" v-if="!empty(additional.customfield_dmbron)">
					<span>Bron:</span>
					<span>{{ additional.customfield_dmbron ? additional.customfield_dmbron : 'Onbekend' }}</span>
				</div>
				<div class="appointment-item" v-if="additional.customfield_leadkanaal === 'KMK' || additional.customfield_leadkanaal === 'ThermoTrees'">
					<span>KMK:</span>
					<span>{{ additional.customfield_kmkmedewerker }}</span>
				</div>
				<div class="appointment-item" v-if="additional.kmkReferer != null && additional.kmkReferer.id">
					<span>Aangebracht door:</span>
					<span>
						<a target="_blank" :href="`https://regio.gripp.com/d/company/edit/${additional.kmkReferer.id}`">
							{{ additional.kmkReferer.companyname }}
						</a>
					</span>
				</div>
				<div class="appointment-item">
					<span>Aangemaakt op:</span>
					<span>{{ parseDate(additional.createdon.substring(0, 10)) }}</span>
				</div>
			</div>
		</div>
		<a class="MarkerPopup-phone" :href="'tel:' + phoneNumber" v-if="phoneNumber">
			<PhoneIcon/>
			{{ phoneNumber }}
		</a>
		<div class="MarkerPopup-lastupdated" v-if="data.lastTimeline != null && data.lastTimeline.date">
			{{ data.lastTimeline.date }}
		</div>
		<div class="MarkerPopup-lastTimeline" v-if="data.lastTimeline != null && data.lastTimeline.message">
			{{ data.lastTimeline.message }}
		</div>
		<div class="MarkerPopup-additional" v-if="additional">
			<div v-if="additional.projects.length" class="MarkerPopup-additional-projects">
				<div v-for="(project, i) in additional.projects" v-if="project.deliverydate">Uitvoerdatum<span v-if="i > 0"> {{ i + 1 }}</span>:
					{{ project.deliverydate.replace(' 00:00:00', '') }}
				</div>
			</div>
			<Collapsible v-if="additional.invoices.length" v-for="invoice in additional.invoices" :key="invoice.number">
				<template v-slot:toggler>Factuur: {{ invoice.number }}</template>
				<ol>
					<li v-for="invoiceline in invoice.invoicelines">{{ invoiceline.product }}</li>
				</ol>
			</Collapsible>
		</div>
		<div class="MarkerPopup-tags" v-if="data.tags.length > 0">
			<span v-for="tag in data.tags" :key="tag.name" class="MarkerPopup-tag">{{ tag.name }}</span>
		</div>
		<div class="MarkerPopup-actions">
				<Button @click="onClickAction($event,
						'geen_gehoor')">Geen gehoor
				</Button>
				<DropdownButton>
					<template v-slot:button>Afwijzing</template>
					<Button @click="onClickAction($event, 'akkoord_ander_bedrijf')">Akkoord ander bedrijf</Button>
					<Button @click="onClickAction($event, 'al_binnen_ander_kanaal')">Al binnen ander kanaal</Button>
					<Button @click="onClickAction($event, 'alleen_informatie')">Alleen informatie</Button>
					<Button @click="onClickAction($event, 'doorschuiven_langere_termijn')">Doorschuiven langere termijn
					</Button>
					<Button @click="onClickAction($event, 'eilanden')">Eilanden</Button>
					<Button @click="onClickAction($event, 'geen_interesse_meer')">Geen interesse meer</Button>
					<Button @click="onClickAction($event, 'geschilderd')">Geschilderd</Button>
					<Button @click="onClickAction($event, 'niet_mogelijk')">Niet mogelijk</Button>
					<Button @click="onClickAction($event, 'mbi')">MBI</Button>
					<Button @click="onClickAction($event, 'kalkzandsteen')">Kalkzandsteen</Button>
				</DropdownButton>
				<Button
					@click="onClickCreateAppointment();">Afspraak...
				</Button>
				<Button @click="onClickCreateNote('Planning');">
					Notitie...
				</Button>
				<Button @click="onClickAction($event,
						'opnieuw_geen_gehoor')">@x
				</Button>
				<Button @click="onClickAction($event,
						'foutief_nummer')">Foutief
				</Button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Button from '@/components/Button';
import DropdownButton from '@/components/DropdownButton';
import CreateAppointment from '@/components/mapModal/CreateAppointment.vue';
import CreateNote from '@/components/CreateNote';
import Collapsible from '@/components/Collapsible';
import { PhoneIcon } from 'vue-feather-icons';
import { calculatePlanningAppointmentEndTime, parseDate } from "@/utils";

export default {
	components: {
		Button,
		DropdownButton,
		CreateAppointment,
		PhoneIcon,
		Collapsible,
	},

	props: {
		data: Object
	},

	data() {
		return {
			additional: null,
		};
	},

	beforeMount() {
		this.fetchAdditionalMarkerInfo({id: this.data.id}).then(data => {
			this.additional = data;
		});

		this.fetchAgents();
	},

	computed: {
		...mapState('data', {
			agents: 'agents',
		}),

		phoneNumber() {
			if (!this.empty(this.data.phone)) {
				return this.data.phone;
			} else if (!this.empty(this.data.mobile)) {
				return this.data.mobile
			} else {
				return null;
			}
		},

		fullname() {
			const salutations = {
				1: 'Dhr.',
				2: 'Mevr.',
				3: 'Dhr/Mevr.',
			};

			let name = [];
			if (this.data.salutation !== '') name.push(salutations[parseInt(this.data.salutation)]);
			if (this.data.initials !== '') name.push(this.data.initials);
			if (this.data.infix !== '') name.push(this.data.infix);
			if (this.data.lastname !== '') name.push(this.data.lastname);
			if (name.length === 0) name.push(this.data.companyname);

			return name.join(' ');
		},
	},

	methods: {
		...mapActions({
			fetchAgents: 'data/fetchAgents',
			performAction: 'map/performAction',
			fetchAdditionalMarkerInfo: 'map/fetchAdditionalMarkerInfo'
		}),

		onClickCreateNote(type) {
			this.$modal.show(CreateNote, {data: this.data, type: type}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600,
			});
		},

		onClickCreateAppointment() {
			this.$modal.show(CreateAppointment, {data: this.data}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 1200
			});
		},

		onClickAction(button, type) {
			button.disable();

			this.performAction({
				company_id: this.data.id,
				user_id: this.$store.state.map.viewingUserId,
				type: type,
			}).then(result => {
				button.enable();
				if (type !== 'opnieuw_geen_gehoor') {
					this.$events.emit('map/closePopup');
				}
			}).catch((error) => {
				console.log('error', error);
				console.log('error: possible error dupicated tag');
				button.enable();
			});
		},

		parseDate(date) {
			return parseDate(date);
		},

		calculatePlanningAppointmentEndTime(time, durationHours) {
			return calculatePlanningAppointmentEndTime(time, durationHours);
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		}
	}
};
</script>

<style scoped>
.MarkerPopup-address, .MarkerPopup-appointment {
	border-bottom: 1px solid #eee;
	padding-bottom: 20px;
	margin-bottom: 0.5em;
}

.MarkerPopup-appointment:not(:first-child) {
	margin-top: 1em;
}

.appointment-item {
	display: flex;
	justify-content: space-between;
}
</style>
